export enum CardMode {
    Default = 'default',
    Narrow = 'narrow',
    Stack = 'stack',
}
